import { CombineEventsType, Drill, Manage } from 'config/commonTypes';
import { useRouter } from 'helpers/customHooks';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as action from '../actions/manage';
import { RootState } from '../reducers';

type RouteParams = {
  params: { id: string, playerId: string }
}
export const useManageDispatch = () => {
  const dispatch = useDispatch();
  const { params } = useRouter<RouteParams>();
  const { id:gameId } = params;
  return {
    ...bindActionCreators({ ...action }, dispatch),
    getPractice: (id:string, league:string, isMobile?:boolean) => {
      dispatch(action.getPractice(gameId, id, league, isMobile));
    },
    updatePractice: (practice:Manage, id:string, league:string, type?:string, loader?:boolean, reprocess?:boolean, isMobile?:boolean) => {
      dispatch(action.updatePractice(practice, gameId, id, league, loader, type, reprocess, isMobile));
    },
    endPractice: (practice:Manage, drills:Drill[], isMobile?:boolean) => {
      dispatch(action.endPractice(practice, drills, gameId, isMobile));
    },
    startPeriod: (practice:Manage, index:number, practiceId?:string, skip?: boolean, isMobile?:boolean) => {
      dispatch(action.startPeriod(practice, index, gameId, practiceId, skip, isMobile));
    },
    startPractice: (practice:Manage) => {
      dispatch(action.startPractice(practice, gameId));
    },
    startPracticeMobile: (practice:Manage) => {
      dispatch(action.startPracticeMobile(practice, gameId));
    },
    endPeriod: (practice:Manage, index:number, skip?:boolean, isMobile?:boolean) => {
      dispatch(action.endPeriod(practice, index, gameId, skip, isMobile));
    },
    partialReprocess: (gameId: string, playerList: string[], practice:Manage, id:string, league:string, type?:string)=>{
      dispatch(action.partialReprocess(gameId, playerList, practice, id, league, type ));
    },
    createCombineEvent: (practiceId:string, combineEvent: any, gameId: string, league:string)=>{
      dispatch(action.createCombineEvent(practiceId, combineEvent, gameId, league));
    },
    updateCombineEvent: (practiceId:string, combineEvent: CombineEventsType, combineEventId: string, gameId:string, league:string)=>{
      dispatch(action.updateCombineEvent(practiceId, combineEvent, combineEventId, gameId, league));
    },
    finalizeCombine: (practiceId: string)=>{
      dispatch(action.finalizeCombine(practiceId));
    },
  };
};
